import $ from 'jquery';

$('.js-contacts-social-button-dropdown-links').click(function () {
    $(this).toggleClass('contacts-social-button-dropdown-links--active');
    if ($('.js-contacts-social-button-dropdown-links').hasClass('contacts-social-button-dropdown-links--active')){
        $('.contacts-social-button-dropdown-content').fadeIn()
    }else {
        $('.contacts-social-button-dropdown-content').fadeOut()
    }
});


$(document).mouseup(function (e) {
    const links = $('.js-contacts-social-button-dropdown-links');
    if (links.has(e.target).length === 0){
        links.removeClass('contacts-social-button-dropdown-links--active');
    }
});
